import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { apiReferralsList, apiReferralsView } from 'Services/AdminService'

export const getData = createAsyncThunk('admin/referrals/getData', async datas => {
    const { data } = await apiReferralsList(datas)
    return data
})

export const getView = createAsyncThunk('admin/referrals/getView', async id => {
    if (!id) return viewData
    const { data } = await apiReferralsView(id)
    data.image = ''
    return data
})

const viewData = {
    first_name: '',
    last_name: '',
    email: '',
    mobile_no: '',
    image: '',
}

export const referralsSlice = createSlice({
    name: 'admin/referrals',
    initialState: {
        loading: true,
        view: viewData,
        data: [],
        total: 0,
        table: {
            page: 1,
            length: 10,
            search: '',
            column: '',
            dir: '',
        },
    },
    reducers: {
        setData: (state, { payload }) => {
            state.data = payload
        },
        setTableData: (state, { payload }) => {
            state.table = payload
        },
    },
    extraReducers: builder => {
        builder
            .addCase(getData.pending, state => {
                state.loading = true
            })
            .addCase(getData.fulfilled, (state, { payload }) => {
                state.loading = false
                state.data = payload.data
                state.total = payload.total
            })
            .addCase(getData.rejected, state => {
                state.loading = false
                state.data = []
                state.total = 0
            })
            .addCase(getView.pending, state => {
                state.loading = true
                state.view = viewData
            })
            .addCase(getView.fulfilled, (state, { payload }) => {
                state.loading = false
                state.view = payload
            })
    },
})

export const { setData, setTableData } = referralsSlice.actions

export default referralsSlice.reducer
